import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'

function LeadCard({ name, photo, role, accent }) {
  const initials = name?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
  return (
    <div className="flex items-center gap-4">
      <div className={`w-14 h-14 rounded-full overflow-hidden border-2 flex items-center justify-center shrink-0 ${
        accent
          ? 'bg-green-900/50 border-green-600/50'
          : 'bg-green-900/20 border-green-800/30'
      }`}>
        {photo
          ? <img src={photo} alt={name} className="w-full h-full object-cover" />
          : <span className="text-white font-black text-sm">{initials}</span>
        }
      </div>
      <div>
        <div className={`text-xs font-bold uppercase tracking-widest mb-0.5 ${
          accent ? 'text-green-600 dark:text-green-400' : 'text-gray-500'
        }`}>
          {role}
        </div>
        <div className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-tight">
          {name || 'Not assigned'}
        </div>
      </div>
    </div>
  )
}

export default function ChapterLeads({ supporter }) {
  const [chapter, setChapter] = useState(null)

  useEffect(() => {
    if (!supporter?.chapter_id) return
    supabase
      .from('chapters')
      .select('name, chairperson_name, chairperson_photo, vice_name, vice_photo')
      .eq('id', supporter.chapter_id)
      .single()
      .then(({ data }) => { if (data) setChapter(data) })
  }, [supporter?.chapter_id])

  const hasLeads = chapter?.chairperson_name || chapter?.vice_name

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Chapter Leadership
      </div>

      {!chapter ? (
        <div className="text-gray-400 text-sm text-center py-8">Loading...</div>
      ) : !hasLeads ? (
        <div className="text-gray-400 text-sm text-center py-8">
          No leadership details on record for {chapter.name}
        </div>
      ) : (
        <div className="flex flex-col gap-5">
          {chapter.chairperson_name && (
            <LeadCard
              name={chapter.chairperson_name}
              photo={chapter.chairperson_photo}
              role="Chairperson"
              accent={true}
            />
          )}
          {chapter.chairperson_name && chapter.vice_name && (
            <div className="border-t border-gray-200 dark:border-white/10" />
          )}
          {chapter.vice_name && (
            <LeadCard
              name={chapter.vice_name}
              photo={chapter.vice_photo}
              role="Vice Chairperson"
              accent={false}
            />
          )}
        </div>
      )}

      <div className="mt-6 pt-4 border-t border-gray-200 dark:border-white/10">
        <div className="text-xs text-gray-400 uppercase tracking-widest">
          {chapter?.name} Chapter
        </div>
      </div>
    </div>
  )
}